/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.ExerciseChirpService
 */
import * as References from './ExerciseChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.ExerciseChirpService#getRequirements
 */
export const GET_REQUIREMENTS_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_ExerciseChirpService_getRequirements';
export const GET_REQUIREMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_REQUIREMENTS_QUERY_FIELD_NAME,
  args: ['contentId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRequirementsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});